const PlusIcon = () => {
    return (  
        <div className="size-6">
            <img src="images/plus-sign.svg" alt="" className="w-full h-full"/>
        </div>
    );
}
 
export default PlusIcon;